import { useState, type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

type SoftProps = {
  onConfirm: (reason: string) => void;
  onCancel: () => void;
  isPending: boolean;
};

type ConfirmButtonsProps = {
  onCancel: () => void;
  onConfirm: () => void;
  isPending: boolean;
  label: string;
  variant: 'primary' | 'danger';
  pendingLabel?: string;
};

function ConfirmButtons(p: ConfirmButtonsProps): ReactNode {
  const label = p.isPending && p.pendingLabel ? p.pendingLabel : p.label;
  return (
    <div className="flex items-center justify-end gap-sm">
      <Button
        variant="ghost"
        size="sm"
        onClick={p.onCancel}
        disabled={p.isPending}
      >
        Cancelar
      </Button>
      <Button
        variant={p.variant}
        size="sm"
        onClick={p.onConfirm}
        disabled={p.isPending}
      >
        {label}
      </Button>
    </div>
  );
}

function ReasonField({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}): ReactNode {
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value.slice(0, 200))}
      placeholder="Motivo (opcional)"
      rows={2}
      className="w-full rounded-md border border-white/[0.06] bg-surface-elevated p-sm text-xs text-text-primary placeholder:text-text-tertiary focus:border-brand-red focus:outline-none"
    />
  );
}

export function CreatorDeleteConfirm({
  onConfirm,
  onCancel,
  isPending,
}: SoftProps): ReactNode {
  const [reason, setReason] = useState('');
  return (
    <div className="flex flex-col gap-sm border-t border-white/[0.06] pt-base">
      <p className="text-xs text-text-secondary">
        Se moverá a tu papelera. Puedes restaurarlo después.
      </p>
      <ReasonField value={reason} onChange={setReason} />
      <ConfirmButtons
        onCancel={onCancel}
        onConfirm={() => onConfirm(reason)}
        isPending={isPending}
        label="Mover a papelera"
        pendingLabel="Eliminando…"
        variant="danger"
      />
    </div>
  );
}

export { ConfirmButtons };
